import { render, staticRenderFns } from "./BrandProfile.vue?vue&type=template&id=a9512814"
import script from "./BrandProfile.vue?vue&type=script&lang=js"
export * from "./BrandProfile.vue?vue&type=script&lang=js"
import style0 from "./BrandProfile.vue?vue&type=style&index=0&id=a9512814&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports